// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  margin: -10px -4px;
}

::ng-deep .notify-panel {
  background-color: #fff;
  color: #333;
}

.mat-icon {
  margin-top: 8px;
  margin-right: 10px;
  float: left;
}

.notify-container {
  flex: 1;
  overflow-y: auto;
}

.notify-message {
  flex: 1;
  line-height: normal;
  padding: 8px 0;
  word-break: break-word;
  float: left;
}

.mat-simple-snackbar-action {
  display: flex;
  align-items: center;
}

.default {
  cursor: default;
}

.pointer {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/notification/push-notify/push-notify.component.scss"],"names":[],"mappings":"AAAA;EACG,aAAA;EACA,kBAAA;AACH;;AAEA;EACG,sBAAA;EACA,WAAA;AACH;;AAEA;EACG,eAAA;EACA,kBAAA;EACA,WAAA;AACH;;AAEA;EACG,OAAA;EACA,gBAAA;AACH;;AAEA;EACG,OAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;EACA,WAAA;AACH;;AAEA;EACG,aAAA;EACA,mBAAA;AACH;;AAEA;EACG,eAAA;AACH;;AAEA;EACG,eAAA;AACH","sourcesContent":[":host {\n   display: flex;\n   margin: -10px -4px;\n}\n\n::ng-deep .notify-panel {\n   background-color: #fff;\n   color: #333;\n}\n\n.mat-icon {\n   margin-top: 8px;\n   margin-right: 10px;\n   float:left;\n}\n\n.notify-container {\n   flex: 1;\n   overflow-y: auto;\n}\n\n.notify-message {\n   flex: 1;\n   line-height: normal;\n   padding: 8px 0;\n   word-break: break-word;\n   float: left;\n}\n\n.mat-simple-snackbar-action {\n   display: flex;\n   align-items: center;\n}\n\n.default {\n   cursor: default;\n}\n\n.pointer {\n   cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
